module.exports = __webpack_public_path__ + "img/i_kefu.76dcec72.svg";